/**
 * Run the function from the array and remove it so its not called again.
 *
 * @param { Array } callbackArray The array full of callback functions.
 */
const load = ( callbackArray = [] ) => {
	const callback = callbackArray.shift();

	if ( typeof callback === 'function' ) {
		callback();
	}
}

/**
 * This observer modifies the object push for the queue and adds the callback function
 * every time a item is added to the queue
 *
 * @param { Array } callbackArray The array full of callback functions.
 */
const observeQueue = ( callbackArray ) => {
	callbackArray.push = ( e ) => {
		Array.prototype.push.call( callbackArray, e );
		load( callbackArray );
	};
}

/**
 * Observes an array full of callback functions and executes any already in the array and any in the future.
 *
 * @param { Array } callbackArray The array full of callback functions.
 */
export const observe = ( callbackArray ) => {

	// Initial check of the "callbackArray" array to see if anything has been added, then observe.
	if ( typeof callbackArray !== 'undefined' &&
		Array.isArray( callbackArray ) ) {

		// Loop through current commands queued on the "callbackArray" array.
		while ( callbackArray.length > 0 ) {
			load( callbackArray );
		}

		// Observe any future commands pushed to the "callbackArray" array.
		observeQueue( callbackArray );
	}
}
